const allSliders = () => {
    singleSlider();
    benefitSlider();
    cardSlider();
}

const singleSlider = () => {
    let sliders = document.querySelectorAll('.image-slider');
    sliders.forEach(function (slider, index) {
        //Initialise the slider
        const cSwiper = new Swiper(slider.querySelector('.image-slider__swiper'), {
            slidesPerView: 1,
            centeredSlides: false,
            rewind: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        });

        const sliderNextArrow = slider.querySelector('.js__slider__swiper-next');
        const sliderPrevArrow = slider.querySelector('.js__slider__swiper-prev');

        //Move to next slide if 'next' arrow clicked
        if(sliderNextArrow){
        	sliderNextArrow.addEventListener('click', (event) => {
        		cSwiper.slideNext();
        	})
        }

        if(sliderPrevArrow){
        	sliderPrevArrow.addEventListener('click', (event) => {
        		cSwiper.slidePrev();
        	})
        }
    });
}

const cardSlider = () => {
    let sliders = document.querySelectorAll('.card-slider-section');
    sliders.forEach(function (slider, index) {
        //Initialise the slider
        const cSwiper = new Swiper(slider.querySelector('.card-slider-section__swiper'), {
            slidesPerView: 1,
            centeredSlides: false,
            rewind: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        });

        const sliderNextArrow = slider.querySelector('.js__slider__swiper-next');
        const sliderPrevArrow = slider.querySelector('.js__slider__swiper-prev');

        //Move to next slide if 'next' arrow clicked
        if(sliderNextArrow){
            sliderNextArrow.addEventListener('click', (event) => {
                cSwiper.slideNext();
            })
        }

        if(sliderPrevArrow){
            sliderPrevArrow.addEventListener('click', (event) => {
                cSwiper.slidePrev();
            })
        }
    });
}

const benefitSlider = () => {
    let sliders = document.querySelectorAll('.benefit-slider');
    if (sliders) {
        sliders.forEach(function (slider, index) {
            //Initialise the slider
            const cSwiper = new Swiper(slider.querySelector('.benefit-slider__swiper'), {
                slidesPerView: 1,
                centeredSlides: true,
                watchSlidesProgress: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                rewind: true,
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
            });

            const sliderNextArrow = slider.querySelector('.js__slider__swiper-next');
            const sliderPrevArrow = slider.querySelector('.js__slider__swiper-prev');

            //Move to next slide if 'next' arrow clicked
            if (sliderNextArrow) {
                sliderNextArrow.addEventListener('click', (event) => {
                    cSwiper.slideNext();
                })
            }

            if (sliderPrevArrow) {
                sliderPrevArrow.addEventListener('click', (event) => {
                    cSwiper.slidePrev();
                })
            }
        });

        let arches = document.querySelectorAll('.benefit-slider__title--arch');
        arches.forEach(function (arch, index) {
            new CircleType(arch).radius(300);
        });
    }
}